// Motore di calcolo Apollo.AI (simulato ma coerente)

// Dizionario città italiane: [nome, zona, regione, lat, lng]
const CITY_LIST = [
  ["Milano", "Nord", "Lombardia", 45.4642, 9.19], ["Torino", "Nord", "Piemonte", 45.0703, 7.6869],
  ["Genova", "Nord", "Liguria", 44.4056, 8.9463], ["Venezia", "Nord", "Veneto", 45.4408, 12.3155],
  ["Verona", "Nord", "Veneto", 45.4384, 10.9916], ["Padova", "Nord", "Veneto", 45.4064, 11.8768],
  ["Vicenza", "Nord", "Veneto", 45.5455, 11.5354], ["Treviso", "Nord", "Veneto", 45.6669, 12.243],
  ["Trieste", "Nord", "Friuli-Venezia Giulia", 45.6495, 13.7768], ["Udine", "Nord", "Friuli-Venezia Giulia", 46.0711, 13.2346],
  ["Bologna", "Nord", "Emilia-Romagna", 44.4949, 11.3426], ["Modena", "Nord", "Emilia-Romagna", 44.6471, 10.9252],
  ["Parma", "Nord", "Emilia-Romagna", 44.8015, 10.3279], ["Reggio Emilia", "Nord", "Emilia-Romagna", 44.6989, 10.6297],
  ["Ferrara", "Nord", "Emilia-Romagna", 44.8381, 11.6198], ["Rimini", "Nord", "Emilia-Romagna", 44.0678, 12.5695],
  ["Ravenna", "Nord", "Emilia-Romagna", 44.4184, 12.2035], ["Piacenza", "Nord", "Emilia-Romagna", 45.0526, 9.693],
  ["Bergamo", "Nord", "Lombardia", 45.6983, 9.6773], ["Brescia", "Nord", "Lombardia", 45.5416, 10.2118],
  ["Como", "Nord", "Lombardia", 45.8081, 9.0852], ["Monza", "Nord", "Lombardia", 45.5845, 9.2744],
  ["Varese", "Nord", "Lombardia", 45.8206, 8.8251], ["Pavia", "Nord", "Lombardia", 45.1847, 9.1582],
  ["Cremona", "Nord", "Lombardia", 45.1332, 10.0227], ["Mantova", "Nord", "Lombardia", 45.1564, 10.7914],
  ["Lecco", "Nord", "Lombardia", 45.8566, 9.3977], ["Lodi", "Nord", "Lombardia", 45.3097, 9.5037],
  ["Novara", "Nord", "Piemonte", 45.4469, 8.6222], ["Alessandria", "Nord", "Piemonte", 44.9126, 8.6152],
  ["Asti", "Nord", "Piemonte", 44.9008, 8.2064], ["Cuneo", "Nord", "Piemonte", 44.3845, 7.5427],
  ["Aosta", "Nord", "Valle d'Aosta", 45.7372, 7.3201], ["Trento", "Nord", "Trentino-Alto Adige", 46.0748, 11.1217],
  ["Bolzano", "Nord", "Trentino-Alto Adige", 46.4983, 11.3548], ["La Spezia", "Nord", "Liguria", 44.1025, 9.8241],
  ["Savona", "Nord", "Liguria", 44.3091, 8.4772],
  ["Roma", "Centro", "Lazio", 41.9028, 12.4964], ["Firenze", "Centro", "Toscana", 43.7696, 11.2558],
  ["Perugia", "Centro", "Umbria", 43.1107, 12.3908], ["Terni", "Centro", "Umbria", 42.5636, 12.6427],
  ["Ancona", "Centro", "Marche", 43.6158, 13.5189], ["Pesaro", "Centro", "Marche", 43.9098, 12.9131],
  ["Macerata", "Centro", "Marche", 43.3007, 13.4535], ["Ascoli Piceno", "Centro", "Marche", 42.8539, 13.5745],
  ["Pisa", "Centro", "Toscana", 43.7228, 10.4017], ["Livorno", "Centro", "Toscana", 43.5485, 10.3106],
  ["Lucca", "Centro", "Toscana", 43.8429, 10.5027], ["Siena", "Centro", "Toscana", 43.3188, 11.3308],
  ["Arezzo", "Centro", "Toscana", 43.4633, 11.8796], ["Prato", "Centro", "Toscana", 43.8777, 11.1022],
  ["Pistoia", "Centro", "Toscana", 43.9303, 10.9078], ["Grosseto", "Centro", "Toscana", 42.7635, 11.1124],
  ["Viterbo", "Centro", "Lazio", 42.4207, 12.1077], ["Latina", "Centro", "Lazio", 41.4676, 12.9036],
  ["Frosinone", "Centro", "Lazio", 41.6396, 13.3426], ["Rieti", "Centro", "Lazio", 42.4048, 12.8567],
  ["L'Aquila", "Centro", "Abruzzo", 42.3498, 13.3995], ["Pescara", "Centro", "Abruzzo", 42.4618, 14.2161],
  ["Chieti", "Centro", "Abruzzo", 42.3512, 14.1675], ["Teramo", "Centro", "Abruzzo", 42.6589, 13.7044],
  ["Napoli", "Sud", "Campania", 40.8518, 14.2681], ["Salerno", "Sud", "Campania", 40.6824, 14.7681],
  ["Caserta", "Sud", "Campania", 41.0732, 14.3329], ["Avellino", "Sud", "Campania", 40.9146, 14.7906],
  ["Benevento", "Sud", "Campania", 41.1298, 14.7826], ["Bari", "Sud", "Puglia", 41.1171, 16.8719],
  ["Lecce", "Sud", "Puglia", 40.3515, 18.175], ["Taranto", "Sud", "Puglia", 40.4644, 17.247],
  ["Brindisi", "Sud", "Puglia", 40.6327, 17.9418], ["Foggia", "Sud", "Puglia", 41.4622, 15.5446],
  ["Barletta", "Sud", "Puglia", 41.3196, 16.2838], ["Andria", "Sud", "Puglia", 41.2317, 16.2917],
  ["Potenza", "Sud", "Basilicata", 40.6404, 15.8056], ["Matera", "Sud", "Basilicata", 40.6664, 16.6043],
  ["Cosenza", "Sud", "Calabria", 39.2983, 16.2537], ["Catanzaro", "Sud", "Calabria", 38.9098, 16.5877],
  ["Reggio Calabria", "Sud", "Calabria", 38.1113, 15.6473], ["Crotone", "Sud", "Calabria", 39.0808, 17.1271],
  ["Palermo", "Sud", "Sicilia", 38.1157, 13.3615], ["Catania", "Sud", "Sicilia", 37.5079, 15.083],
  ["Messina", "Sud", "Sicilia", 38.1938, 15.554], ["Siracusa", "Sud", "Sicilia", 37.0755, 15.2866],
  ["Ragusa", "Sud", "Sicilia", 36.9269, 14.7255], ["Trapani", "Sud", "Sicilia", 38.0176, 12.5365],
  ["Agrigento", "Sud", "Sicilia", 37.3111, 13.5765], ["Cagliari", "Sud", "Sardegna", 39.2238, 9.1217],
  ["Sassari", "Sud", "Sardegna", 40.7259, 8.5557], ["Olbia", "Sud", "Sardegna", 40.9234, 9.4964],
  ["Campobasso", "Sud", "Molise", 41.5603, 14.6627],
  ["Lugano", "Ticino", "Ticino", 46.0037, 8.9511], ["Bellinzona", "Ticino", "Ticino", 46.1956, 9.0238],
  ["Locarno", "Ticino", "Ticino", 46.1708, 8.7995], ["Mendrisio", "Ticino", "Ticino", 45.8703, 8.9817],
  ["Chiasso", "Ticino", "Ticino", 45.8323, 9.0313], ["Ascona", "Ticino", "Ticino", 46.1573, 8.7726],
  ["Zurigo", "Svizzera", "Zurigo", 47.3769, 8.5417], ["Zurich", "Svizzera", "Zurigo", 47.3769, 8.5417],
  ["Ginevra", "Svizzera", "Ginevra", 46.2044, 6.1432], ["Geneve", "Svizzera", "Ginevra", 46.2044, 6.1432],
  ["Basilea", "Svizzera", "Basilea Città", 47.5596, 7.5886], ["Basel", "Svizzera", "Basilea Città", 47.5596, 7.5886],
  ["Berna", "Svizzera", "Berna", 46.948, 7.4474], ["Bern", "Svizzera", "Berna", 46.948, 7.4474],
  ["Losanna", "Svizzera", "Vaud", 46.5197, 6.6323], ["Lausanne", "Svizzera", "Vaud", 46.5197, 6.6323],
  ["Lucerna", "Svizzera", "Lucerna", 47.0502, 8.3093], ["Luzern", "Svizzera", "Lucerna", 47.0502, 8.3093],
  ["San Gallo", "Svizzera", "San Gallo", 47.4245, 9.3767], ["St Gallen", "Svizzera", "San Gallo", 47.4245, 9.3767],
  ["Winterthur", "Svizzera", "Zurigo", 47.4988, 8.7237], ["Coira", "Svizzera", "Grigioni", 46.8508, 9.532],
  ["Chur", "Svizzera", "Grigioni", 46.8508, 9.532], ["Friburgo", "Svizzera", "Friburgo", 46.8065, 7.1619],
];

// Regioni italiane (nomi restituiti da Google) → zona
const REGION_ZONE = {
  Lombardia: "Nord", Piemonte: "Nord", "Valle d'Aosta": "Nord", "Trentino-Alto Adige": "Nord", Veneto: "Nord",
  "Friuli-Venezia Giulia": "Nord", Liguria: "Nord", "Emilia-Romagna": "Nord",
  Toscana: "Centro", Umbria: "Centro", Marche: "Centro", Lazio: "Centro", Abruzzo: "Centro",
  Molise: "Sud", Campania: "Sud", Puglia: "Sud", Basilicata: "Sud", Calabria: "Sud", Sicilia: "Sud", Sardegna: "Sud",
};

const normalize = (s) =>
  ` ${s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z]+/g, " ").trim()} `;

// Chiavi ordinate per lunghezza: "reggio calabria" viene verificata prima di città più corte
const CITIES = CITY_LIST.map(([name, zone, region, lat, lng]) => ({ key: normalize(name), name, zone, region, lat, lng }))
  .sort((a, b) => b.key.length - a.key.length);

export const BUILDING_TYPES = [
  { value: "Villa Unifamiliare", kwh: 4500 },
  { value: "Condominio", kwh: 18000 },
  { value: "Negozio", kwh: 9000 },
  { value: "Capannone Industriale", kwh: 120000 },
  { value: "Ufficio", kwh: 15000 },
];

// Rendimento annuo in kWh per kWp installato, per zona
export const ZONE_YIELD = { Nord: 900, Centro: 1000, Sud: 1100, Ticino: 1050, Svizzera: 950 };
export const ZONE_LABEL = { Nord: "Nord", Centro: "Centro", Sud: "Sud", Ticino: "Ticino (CH)", Svizzera: "Svizzera" };
const PANEL_KW = 0.4; // Pannello standard 400 W

// Prezzo medio energia (modificabile): Italia in EUR, Svizzera in CHF
export const ENERGY_PRICE = { EUR: 0.3, CHF: 0.29 };

// Deduce la zona dalla città digitata; se non riconosciuta → Centro (default)
export function detectLocation(text) {
  const n = normalize(text || "");
  const hit = CITIES.find((c) => n.includes(c.key));
  if (!hit) return { city: null, zone: "Centro", region: null, lat: null, lng: null };
  return { city: hit.name, zone: hit.zone, region: hit.region, lat: hit.lat, lng: hit.lng };
}

// Zona dai dati Google (paese/regione) se disponibili, altrimenti dal dizionario locale
function resolveLocation(address, geo) {
  const local = detectLocation(address);
  if (!geo) return local;
  let zone = local.zone;
  if (geo.country === "CH") zone = (geo.region || "").includes("Ticino") ? "Ticino" : "Svizzera";
  else if (geo.country === "IT" && REGION_ZONE[geo.region]) zone = REGION_ZONE[geo.region];
  return { city: geo.city || local.city, zone, region: geo.region || local.region, lat: geo.lat, lng: geo.lng };
}

// Fattibilità 85–96%: Sud + consumo alto = 96, Nord + consumo basso = 85, default 90
function feasibility(zone, kwh) {
  const base = { Nord: 87, Centro: 90, Sud: 93, Ticino: 90, Svizzera: 87 }[zone];
  const consumptionBonus = kwh >= 6000 ? 3 : kwh < 3000 ? -2 : 0;
  return Math.min(96, Math.max(85, base + consumptionBonus));
}

// geo = risposta di /api/solar (Google Geocoding + Solar API) oppure null
export function calculate({ address, buildingType, consumption }, geo = null) {
  const location = resolveLocation(address, geo);
  const typeDefault = BUILDING_TYPES.find((t) => t.value === buildingType)?.kwh ?? 4500;
  const userKwh = Number(consumption);
  const kwh = userKwh > 0 ? userKwh : typeDefault; // consumo inserito o stima per tipologia
  const yieldZone = ZONE_YIELD[location.zone];
  // N pannelli = consumo / (0.4 kWp * rendimento zona), arrotondato per eccesso
  const needed = Math.ceil(kwh / (PANEL_KW * yieldZone));
  const roof = geo?.roof?.max_panels ? geo.roof : null;
  // Se il tetto rilevato da satellite non basta, si limita ai pannelli che ci stanno davvero
  const capped = !!roof && needed > roof.max_panels;
  const panels = capped ? roof.max_panels : needed;
  const kwp = Math.round(((panels * 400) / 1000) * 10) / 10; // kWp = N * 400 W / 1000
  return {
    address: address.trim(),
    buildingType,
    consumptionUsed: kwh,
    consumptionEstimated: !(userKwh > 0),
    panels,
    kwp,
    yieldZone,
    annualProduction: Math.round(kwp * yieldZone),
    ...savingsFor(location.zone, Math.round(kwp * yieldZone), kwh),
    feasibility: Math.max(85, feasibility(location.zone, kwh) - (capped ? 2 : 0)),
    roof,
    capped,
    neededPanels: needed,
    formattedAddress: geo?.formatted_address || null,
    ...location,
  };
}

// Risparmio annuo = energia prodotta che copre i consumi (max il consumo) × prezzo kWh
function savingsFor(zone, production, kwh) {
  const currency = zone === "Ticino" || zone === "Svizzera" ? "CHF" : "EUR";
  const price = ENERGY_PRICE[currency];
  return { currency, price, savings: Math.round(Math.min(production, kwh) * price) };
}

// Formato con separatore delle migliaia sempre presente (es. 1.740 CHF, 1.800 €)
export const fmtMoney = (v, currency) =>
  `${Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} ${currency === "EUR" ? "€" : "CHF"}`;

export const fmtKwp = (v) => v.toLocaleString("it-IT", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
